import { render } from "./MarketProductAttrList.vue?vue&type=template&id=2b24f9de"
import script from "./MarketProductAttrList.vue?vue&type=script&lang=js"
export * from "./MarketProductAttrList.vue?vue&type=script&lang=js"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__